import { h, Fragment } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";

import { Box, Button, Chip, FormControlLabel, Grid, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";

import VerificationPhoneCodeDialog from "../PopUps/VerificationPhoneCodeDialog";
//import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import { resendconfmail } from "../Common/functions";
import { AppContext } from "../../AppContext";
import { DatePicker } from '@mui/x-date-pickers';

export default function UserDetails1({ state, handleChange, mode }) {
	console.log("render UserDetails1");
	const [stateVerificationPhoneCodeDialog, setStateVerificationPhoneCodeDialog] = useState({
		open: false,
	});
	const handleCloseVerificationPhoneCodeDialog = () => {
		setStateVerificationPhoneCodeDialog({
			...stateVerificationPhoneCodeDialog,
			open: false,
		});
	};
	const app = useContext(AppContext);
	useEffect(() => {

		if (state.phone1_init !== null && !state.phone1_checked) {
			setStateVerificationPhoneCodeDialog({
				open: true,
			});
		}
	}, [state]);

	return (
		<Fragment style="padding: 0px">
			<VerificationPhoneCodeDialog state={stateVerificationPhoneCodeDialog} onClose={handleCloseVerificationPhoneCodeDialog} />
			<Grid container spacing={1}>
				<Grid container item sm={12} md={6}>
					<Grid item xs={12} sm={6}>
						<RadioGroup
							row
							aria-label="gender"
							name="gender"
							value={state.gender}
							onChange={handleChange}

						>
							<FormControlLabel
								value={"1"}
								control={<Radio size="small" color="primary" />}
								//label={"Mme"}
								label={<Typography variant="body1" style={{

									color: (state.gender === null || state.gender === undefined || state.gender === "") ? "#FF3426" : ""

								}}>Mme</Typography>}
								disabled={state.ro || (mode == "DU")}

							/>
							<FormControlLabel value={"2"} control={<Radio size="small" color="primary" />}
								label={<Typography variant="body1" style={{

									color: (state.gender === null || state.gender === undefined || state.gender === "") ? "#FF3426" : ""

								}}>M</Typography>}
								disabled={state.ro || (mode == "DU")} />
						</RadioGroup>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="first_name"
							name="first_name"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
								backgroundColor: (state.first_name === null || state.first_name === undefined || state.first_name === "") ? "#FFDAD7" : ""
							}}
							placeholder="Nom *"
							fullWidth
							margin="dense"
							size="small"
							value={state.first_name}
							onChange={handleChange}
							required
							disabled={state.ro || (mode == "DU")}
						/>
					</Grid>
				</Grid>

				<Grid container item sm={12} md={6}>
					<TextField
						id="last_name"
						name="last_name"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
							backgroundColor: (state.last_name === null || state.last_name === undefined || state.last_name === "") ? "#FFDAD7" : ""
						}}
						placeholder="Prénom *"
						fullWidth
						margin="dense"
						size="small"
						value={state.last_name}
						onChange={handleChange}
						required
						disabled={state.ro || (mode == "DU")}
					/>
				</Grid>
				{!state.represented && <Grid item xs={12}>
					<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
						<Box sx={{ flexGrow: 1 }}>
							<TextField
								id="email"
								name="email"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Email"
								fullWidth
								margin="dense"
								size="small"
								value={state.email}
								onChange={handleChange}
								disabled
							/>
						</Box>
						<Box p={1}>
							{state.mail_ok && (
								<Chip size="small" label="Confirmé" color="success" style="color: white; background-color: rgb(46, 125, 50);" />
							)}
							{!state.mail_ok && <Chip size="small" label="Pas confirmé" color="primary" />}
							{!state.mail_ok && (

								<Button
									//variant="outlined"
									//style="min-width: 300px;"
									onClick={() => {
										resendconfmail(app);
									}}
								>
									Renvoyer un mail de confirmation
								</Button>

							)}
						</Box>
					</Box>
				</Grid>}

				{!state.represented && <Grid container item xs={12} alignItems="center">
					<Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
						<Grid item xs={6} lg={6}>
							<TextField
								id="phone1"
								name="phone1"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
									backgroundColor: (state.phone1 === null || state.phone1 === undefined || state.phone1 === "") ? "#FFDAD7" : ""
								}}
								placeholder="Téléphone principal *"
								fullWidth
								margin="dense"
								size="small"
								value={state.phone1}
								onChange={handleChange}
								required
								disabled={state.ro}
							/>
						</Grid>
						<Grid item xs={6} lg={6} textAlign="center">
							<Stack flexDirection={"row"} alignItems={"center"} justifyContent={"flex-start"}>
								{!state.phone1_checked && <Chip size="small" label="Pas confirmé" clickable color="primary" />}
								{state.phone1_checked && (
									<Chip size="small" label="Confirmé" color="primary" style="color: white; background-color: rgb(46, 125, 50);" />
								)}
								{state.phone1_init !== null && !state.phone1_checked && (
									<Button
										//variant="outlined"
										//style="min-width: 300px;"
										onClick={() => {
											setStateVerificationPhoneCodeDialog({
												open: true,
											});
										}}
									>
										Vérifier le numéro
									</Button>
								)}
							</Stack>
						</Grid>
					</Grid>
				</Grid>}

				<Grid item xs={12} sm={6}>
					<Typography variant="body1">Date et lieu de naissance</Typography>
					{/* <Typography variant="body1">Date et <span onClick={() => {


						handleChange({ target: { name: "phone1", value: "0637574129" } });
					}
					}>lieu</span> de <span onClick={() => {

						handleChange({ target: { name: "birth_date", value: "01/01/1970" } });

					}
					}>naissance</span></Typography> */}
					<Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
						<DatePicker
							inputFormat="dd/MM/yyyy"
							disableFuture
							//openTo="year"
							//views={['year', 'month', 'day']}

							value={state.birth_date}
							onChange={(date) => {
								if (date) {
									console.log(date);
									date.setHours(12, 0, 0);

									handleChange({ target: { name: "birth_date", value: date } });
								}

							}}
							renderInput={(params) => <TextField size="small" {...params} style={{

								backgroundColor: (state.birth_date === null || state.birth_date === undefined || state.birth_date === "") ? "#FFDAD7" : ""

							}} />}
							disabled={state.ro || (mode == "DU")}

						/>
						<TextField
							id="birth_place"
							name="birth_place"
							variant="outlined"
							style={{
								marginTop: 0,
								marginLeft: 10,
								backgroundColor: (state.birth_place === null || state.birth_place === undefined || state.birth_place === "") ? "#FFDAD7" : ""
								//backgroundColor: (state.birth_place === undefined || state.birth_place === "") ? "#FF342661" : ""

							}}
							placeholder="Lieu de naissance *"
							fullWidth
							margin="dense"
							size="small"
							value={state.birth_place}
							onChange={handleChange}
							disabled={state.ro || (mode == "DU")}

						/>
					</Stack>
				</Grid>
			</Grid >
		</Fragment >
	);
}
